import React, { useState } from 'react';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from './ui/dialog';
import { Button } from './ui/button';
import { ArrowRight, Lock } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { api } from '../utils/api';
import { toast } from 'sonner';
import { CreditPackCards } from './CreditPackCards';

/**
 * BILLING-02 — Credit pack purchase modal.
 *
 * Props:
 *   open: boolean
 *   onOpenChange: (open) => void
 *   canBuyCredits: boolean   — false for Starter users; shows upgrade prompt instead
 */
export const BuyCreditsModal = ({ open, onOpenChange, canBuyCredits = true }) => {
  const navigate = useNavigate();
  const [loadingPack, setLoadingPack] = useState(null);

  const handleBuy = async (pack) => {
    setLoadingPack(pack);
    try {
      const result = await api.buyCredits(pack);
      window.location.href = result.checkout_url;
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === 'string' ? detail : 'Erro ao iniciar checkout.');
      setLoadingPack(null);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="buy-credits-modal" className="sm:max-w-3xl">
        {!canBuyCredits ? (
          <>
            <DialogHeader>
              <DialogTitle className="flex items-center gap-2">
                <Lock className="h-5 w-5 text-amber-500" />
                Créditos adicionais
              </DialogTitle>
              <DialogDescription>
                Créditos adicionais estão disponíveis nos planos Solo e Clínica.
              </DialogDescription>
            </DialogHeader>
            <div className="flex justify-end gap-2 pt-4">
              <Button
                variant="ghost"
                onClick={() => onOpenChange(false)}
                data-testid="credits-modal-close"
              >
                Cancelar
              </Button>
              <Button
                onClick={() => { onOpenChange(false); navigate('/billing'); }}
                className="bg-primary hover:bg-primary-hover"
                data-testid="credits-modal-see-plans"
              >
                Fazer upgrade <ArrowRight className="h-4 w-4 ml-2" />
              </Button>
            </div>
          </>
        ) : (
          <>
            <DialogHeader>
              <DialogTitle>Comprar Consultas Adicionais</DialogTitle>
              <DialogDescription>
                Os créditos não expiram e são usados após o limite do seu plano.
              </DialogDescription>
            </DialogHeader>

            <CreditPackCards onBuy={handleBuy} loadingPack={loadingPack} />

            <p className="text-xs text-slate-500 dark:text-slate-400 pt-2">
              Pagamento processado de forma segura pelo Stripe.
            </p>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};
